/*
 *
 * TechnicalIntervention reducer
 *
 */

import { fromJS } from 'immutable';
import { UPLOAD_IMAGE } from './constants';

export const initialState = fromJS({
  images: null,
});

function technicalInterventionReducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_IMAGE:
      return state.setIn(['images'], action.images);
    default:
      return state;
  }
}

export default technicalInterventionReducer;
